<template>
  <div class="datepicker-wrapper">
    <div v-click-outside="hideDatepiker">
      <input type="text" id="readable" :style="cssStyle" readonly @click="toDatepicker" />
      <datepicker id="datepicker" style="display: none" v-model="date" />
      <span class="arrow" @click="toDatepicker"
        ><i
          class="fas fa-angle-down"
          style="color: #77a0d6; width: 12px; height: 7px"
        ></i
      ></span>
    </div>
  </div>
</template>

<script>
import Datepicker from "vue3-datepicker";
export default {
  props:{
    modelValue:{
      type:Date,
      default: new Date() 
    },
    width: {
      type: Number,
      default: 185
    }
  },
  components: {
    Datepicker,
  },
  data() {
    return {
      date: new Date(),
      options: { weekday: "long", month:'short' },
    };
  },
  emits: ['update:modelValue'],
  mounted(){
    this.date = this.modelValue;
  },
  computed:{
    cssStyle(){
      return {
        width: this.width+'px'
      }
    }
  },
  methods: {
    toDatepicker() {
      document.getElementsByClassName("v3dp__popout")[2].style.display =
        "block";
      document.getElementById("datepicker").click();
    },
    hideDatepiker() {
      document.getElementsByClassName("v3dp__popout")[2].style.display = "none";
    },
  },
  watch: {
    date() {
      let [month,weekday] = new Intl.DateTimeFormat(
        this.$i18n.locale,
        this.options
      ).format(this.date).split(' ');
      weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
      document.getElementById("readable").value = `${weekday}, ${this.date.getDate()} ${month.toLowerCase()}`;
      this.$emit('update:modelValue',this.date);
    },
  },
};
</script>
<style>
.v3dp__input_wrapper input {
  outline: none !important;
  background: #f5f5f6;
  border-radius: 5px;
  border: none;
  width: 185px;
  height: 40px;
  padding-left: 15px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #1c1363;
  cursor: pointer;
}
.v3dp__heading {
  flex-direction: row;
}
.v3dp__heading button:nth-child(3) {
  order: 1;
}
.v3dp__heading button:nth-child(1) {
  order: 1;
}
.v3dp__heading__icon svg {
  fill: #006eff !important;
}
</style>
<style scoped>
/* 185*/
input {
  outline: none !important;
  background: #f5f5f6;
  border-radius: 5px;
  border: none;
  height: 40px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #1c1363;
  cursor: pointer;
  padding: 0px 0px 0px 15px !important;
}
:deep(.v3dp__heading__icon) {
  stroke: #006eff !important;
  width: 15px;
  height: 10px;
}
:deep .v3dp__heading__button {
  border-radius: 50%;
  filter: drop-shadow(0px 0px 8px var(--dropdown-shadow));
  background: #fff !important;
  margin-right: 15px;
}
:deep(.v3dp__popout) {
  width: 320px;
  box-shadow: 0px 4px 4px var(--box-shadow);
  border-radius: 5px;
}
:deep(.v3dp__heading__center) {
  text-align: left;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #1c1363;
  background: #fff !important;
  margin-left: 15px;
}
:deep(.v3dp__heading) {
  padding: 15px 0px;
  border-bottom: 1px solid #e8e8e8;
}
:deep(.v3dp__subheading) {
  margin-top: 13px;
}
:deep(.v3dp__body) {
  height: 100%;
}
:deep(.v3dp__divider) {
  display: none;
}
:deep(.v3dp__subheading span) {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: var(--blackText);
}
:deep(.v3dp__elements) {
  margin-top: 22px;
}
:deep(.v3dp__elements button) {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: var(--blueColor);
  padding: 7px 13.5px;
  background-color: white !important;
}

:deep(.v3dp__elements .selected span) {
  background: none !important;
}
:deep(.v3dp__elements button:hover span) {
  color: var(--blueColor) !important;
  background: #fff !important;
}
:deep(.v3dp__elements .selected) {
  background: #006eff !important;
  border-radius: 35px;
}
:deep(.v3dp__elements .selected:hover span) {
  background: none !important;
  color:var(--whiteText) !important;
}
:deep(.v3dp__elements button[disabled]:hover) {
  cursor: not-allowed;
}
:deep(.v3dp__elements button[disabled]:hover span) {
  color: #d5d9e0 !important;
}
.datepicker-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer !important;
}
.arrow {
  position: absolute;
  bottom: 13px;
  right: 15px;
}
</style>